import React from 'react'

export const COLUMNS_DISTRIBUCION_POR_CEREAL = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealSector12',
    label: 'Sector 1-2 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealSector3',
    label: 'Sector 3 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealSector4',
    label: 'Sector 4 [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealSector5',
    label: 'S5 Manipuleo [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  }
]
export const COLUMNS_DISTRIBUCION_POR_CEREAL_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 55,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 55,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealSector12',
    label: 'Sector 1-2 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealSector3',
    label: 'Sector 3 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealSector4',
    label: 'Sector 4 [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealSector5',
    label: 'S5 Manipuleo [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    width: 60,
    mantenerCase: true
  }
]
